<template>
  <div>
    <Component :is="currentComponent" />
  </div>
</template>

<script>
export default {
  name: 'HomePage',

  computed: {
    currentComponent () {
      const doc = this.$route.params.doc
      const version = this.$route.params.version

      if (doc === 'privacy' && version === 'center') {
        return 'PrivacyCenter'
      }

      return 'DocumentViewer'
    }
  }
}
</script>
